<!--
 * @Author: DY
 * @Date: 2022-02-24 15:29:52
 * @LastEditTime: 2022-02-24 16:48:34
 * @Description:
 * @Param:
 * @FilePath: \JT_Mobile_test\src\views\salesTerminal\supplyPlan\planDetails.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles planDetails">
            <van-nav-bar
                :title="titleText"
                left-text="供应计划"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section :class="{'showFontBtn': listType ==='db'}">
                <component ref="comp" :is="currentView"></component>
            </section>
            <footer class="commonFormBtns" v-if="listType ==='db'">
                <van-button plain type="info" @click="opinionsShow = true">
                    不通过
                </van-button>
                <van-button type="info" @click="btnClick_adopt">
                    通过
                </van-button>
            </footer>
            <!-- 审批意见弹出层 -->
            <van-popup
                class="opinionsEject"
                v-model="opinionsShow"
                position="bottom"
            >
                <h5>审批意见：</h5>
                <textarea v-model="approvalOpinions"></textarea>
                <div class="opinionsBtns">
                    <van-button plain type="info" @click="opinionsShow = false">
                        取消
                    </van-button>
                    <van-button type="info" @click="btnClick_Fail">
                        确认
                    </van-button>
                </div>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: '',
    components: {},
    props: {},
    data() {
        return {
            titleText: '',
            listIndex: null,
            listType: '',
            pageName: '',
            currentView: '',
            plan_id: '',
            opinionsShow: false,
            approvalOpinions: '',
        };
    },
    computed: {},
    watch: {},
    created() {
        this.listIndex = this.$route.params.listIndex;
        this.listType = this.$route.params.listType;
        this.pageName = this.$route.params.pageName;
        if (this.pageName === 'planDetails_gl') {
            this.titleText = '骨料计划详情';
        } else if (this.pageName === 'planDetails_fl') {
            this.titleText = '粉料计划详情';
        }
        this.currentView = () => import('./' + this.pageName + '.vue');
        this.plan_id = this.$route.params.plan_id;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 不通过参数
        btnClick_Fail() {
            if (this.approvalOpinions === '') {
                this.$toast('请先填写审批意见');
            } else {
                const requestBody = {
                    id: this.plan_id,
                    approval_status: 3,
                    approval_opinions: this.approvalOpinions,
                };
                this.examineApprove(requestBody);
            }
        },
        // 通过参数
        btnClick_adopt() {
            const requestBody = {
                id: this.plan_id,
                approval_status: 2,
                approval_opinions: '',
            };
            this.examineApprove(requestBody);
        },

        // 审批
        async examineApprove(requestBody) {
            const row = await this.examineApproveRequest(requestBody);
            if (row) {
                this.$toast.success('审批完成');
                this.$router.isBack = 1;
                this.$router.replace({
                    name: 'supplyPlan',
                    params: {
                        approvalCompleted: true,
                        listIndex: this.listIndex,
                    },
                });
                this.$router.go(-1);
            }
        },

        // 审批请求
        examineApproveRequest(requestBody) {
            return this.$axios.$put('/interfaceApi/procurement/daily/plan/approval', requestBody, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.planDetails
    height 100%
    .opinionsEject
        height 230rpx
        padding: 14rpx
        h5
            font-size 16rpx
            color #0285FE
            margin-bottom: 10rpx
        textarea
            width 100%
            height: 120rpx
            resize: none
            border 1px solid #D7D7D7
            border-radius: 2px
            padding: 8rpx
            font-size 14rpx
            line-height: 20rpx
        .opinionsBtns
            text-align: right
            margin-top: 10rpx
            .van-button
                width 80rpx
                height 36rpx
                margin-left: 14rpx
</style>